<svg width="100%"
     height="100%"
     viewBox="0 0 48 48"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true">
  <path id="Rectangle 181"
        d="M26 20C26 23.0376 23.5376 25.5 20.5 25.5C17.4624 25.5 15 23.0376 15 20C15 16.9624 17.4624 14.5 20.5 14.5C23.5376 14.5 26 16.9624 26 20Z"
        fill="#EA3D85" />
  <circle id="Ellipse 48"
          cx="20.1613"
          cy="20.1613"
          r="13.1613"
          stroke="#47464A"
          stroke-width="3"
          stroke-linecap="round" />
  <path id="Vector"
        d="M31.1291 31.1291L41 41"
        stroke="#47464A"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round" />
</svg>